import { Directive, HostListener } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';

@Directive({
  selector: '[fastFormatData]'
})
export class FastFormatDataDirective {
  public abstractControl: AbstractControl;

  constructor(private control: NgControl) {}

  ngOnInit(): void {
    this.abstractControl = this.control.control;
  }

  @HostListener('keyup', ['$event.target.value'])
  inputChanged(value: string): void {
    const regex = /(\d{2})[-|/](\d{2})[-|/](\d{4})/g;
    if (regex.test(value)) {
      this.abstractControl.setValue(new Date(this.transform(value)));
    } else if (/\d{8}/g.test(value)) {
      this.abstractControl.setValue(
        new Date(value.replace(/(\d{2})(\d{2})(\d{4})/, '$2-$1-$3'))
      );
    }
  }

  private transform(value: any): string {
    if (!value || typeof value !== 'string') return '';
    return value.replace(/(\d{2})[-|/](\d{2})[-|/](\d{4})/g, '$2-$1-$3');
  }
}
